import { render, staticRenderFns } from "./GameNavigation.vue?vue&type=template&id=f3bc9e98&scoped=true&"
import script from "./GameNavigation.vue?vue&type=script&lang=js&"
export * from "./GameNavigation.vue?vue&type=script&lang=js&"
import style0 from "./GameNavigation.vue?vue&type=style&index=0&id=f3bc9e98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bc9e98",
  null
  
)

export default component.exports